import React, { useState, useContext } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import UndoIcon from '@mui/icons-material/Undo';
import { useTheme } from '@mui/material/styles';

import ChangeTicketConfirmDialog from './ChangeTicketConfirmDialog';
import useRevertRejection from '../hooks/vendors/useRevertRejection';
import { AppContext } from '../../App';

interface RevertRejectionProps {
  ticketId: number;
  vendorName: string;
}

const RevertRejection: React.FC<RevertRejectionProps> = ({ ticketId, vendorName }) => {
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const { setToast } = useContext(AppContext);

  const { mutate: revertRejection, isPending: isLoading } = useRevertRejection({
    onSuccess: () => {
      setOpen(false);
      setToast({
        variant: 'success',
        open: true,
        message: 'Rejection reverted successfully',
      });
    },
    onError: (error) => {
      console.error('Revert rejection error:', error);
      setToast({
        variant: 'error',
        open: true,
        message: 'Failed to revert rejection. Please try again.',
      });
    },
  });

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    if (!isLoading) {
      setOpen(false);
    }
  };

  const handleConfirm = () => {
    revertRejection(ticketId);
  };

  return (
    <>
      <Tooltip placement="top" title="Revert Rejection" disableFocusListener disableTouchListener>
        <IconButton
          data-cy={`btn-revert-rejection-${vendorName}`}
          onClick={handleClickOpen}
          disabled={isLoading}
          sx={{
            color: theme.palette.warning.main,
            '&:hover': {
              backgroundColor: theme.palette.warning.main + '20',
            },
          }}
        >
          <UndoIcon fontSize="medium" />
        </IconButton>
      </Tooltip>

      <ChangeTicketConfirmDialog
        open={open}
        onClose={handleClose}
        onConfirm={handleConfirm}
        isLoading={isLoading}
        action="revert"
        vendorName={vendorName}
      />
    </>
  );
};

export default RevertRejection;
